import SuggestionThreadView from '@ckeditor/ckeditor5-track-changes/src/ui/view/suggestionthreadview';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import * as _ from "lodash-es";

import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
    class: { ck_button, CK_TRACKCHANGES_BUTTON },
    event: { EXECUTE },
    htmlElement: { SPAN },
    trackChangesLabels: { ACCEPT, DISCARD, SUGGESTION }
} = CkeditorConstants;

export default class CustomTrackChangeView extends SuggestionThreadView {
    constructor(...args) {
        super(...args);
    }

    getTemplate() {
        const templateDefinition = super.getTemplate();
        templateDefinition.children[2].commentInputView.submitButtonView.label = "Post";
        templateDefinition.children[2].commentInputView.submitButtonView.withText = true;
        templateDefinition.children[2].commentInputView.cancelButtonView.withText = true;
        templateDefinition.children[2].commentInputView.submitButtonView._tooltipString = 'Post comment';
        templateDefinition.children[2].commentInputView.cancelButtonView._tooltipString = 'Cancel';
        const buttonArr = this._createImportantButtonView(templateDefinition);
        const templateForButton = {
          tag: SPAN,
          attributes: {
            class: CK_TRACKCHANGES_BUTTON,
          },
          children: []
        }
        _.forEach(buttonArr, btn => templateForButton.children.push(btn))
        templateDefinition.children.splice(1, 0, templateForButton);
        buttonArr[0].on(EXECUTE, () => {
            this.suggestionView.acceptButton.fire(EXECUTE);
        });
        buttonArr[1].on(EXECUTE, () => {
            this.suggestionView.discardButton.fire(EXECUTE);
        });
        return templateDefinition;
    }

    /**
     * Create accept and discard button views
     * @private
     * @returns {ButtonView[]}
     */
    _createImportantButtonView() {
        const buttonUiConfig = [
            { text: ACCEPT, isEnable: true },
            { text: DISCARD, isEnable: true },
        ];

        const buttons = [];
        _.forEach(buttonUiConfig, buttonConfig => {
            const button = new ButtonView(this.locale);
            const t = this.locale.t;

            button.set({
                label: buttonConfig.text,
                class: ck_button + buttonConfig.text.toLowerCase(),
                tooltip: t(buttonConfig.text + ' ' + SUGGESTION),
                withText: true,
                isEnabled: buttonConfig.isEnable
            });
            buttons.push(button);
        });
        return buttons;
    }
}
